import { z } from "zod";

export const interiorSampleSchema = z.object({
  id: z.string().regex(/^[a-z0-9-]{3,80}$/),
  imageUrl: z.string().startsWith("/media/interior-samples/"),
  sourceUrl: z.url().startsWith("https://"),
  author: z.string().min(1).max(200),
  license: z.enum(["CC BY 2.0", "CC BY 4.0", "CC BY-SA 4.0", "Public domain", "Decobaan AI concept"]),
  licenseUrl: z.url().optional(),
  origin: z.enum(["open-license", "ai-concept"]),
  modifications: z.enum(["Cropped and converted to WebP by Decobaan.", "Generated and curated by Decobaan, then converted to WebP."]),
  title: z.object({ ko: z.string().min(1), th: z.string().min(1), en: z.string().min(1) }).strict(),
  spaceType: z.enum(["condo", "house", "hospitality", "restaurant", "retail", "office"]),
  style: z.enum(["modern-tropical", "warm-modern", "thai-contemporary", "compact-living", "commercial"]),
  location: z.string().min(1).max(120),
  width: z.number().int().positive().max(1600),
  height: z.number().int().positive().max(1600),
  bytes: z.number().int().positive().max(1_000_000)
}).strict();

export const interiorSamplesManifestSchema = z.object({
  version: z.literal(1),
  generatedAt: z.iso.datetime(),
  source: z.literal("Decobaan curated: Openverse and original AI concepts"),
  samples: z.array(interiorSampleSchema).min(1).max(100)
}).strict();

export type InteriorSample = z.infer<typeof interiorSampleSchema>;
export type InteriorSamplesManifest = z.infer<typeof interiorSamplesManifestSchema>;
